export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7859.f4b262ad.jpg";